import React from "react";
import { config } from "../../config";
import Header from "../../components/flights/Header";

function AboutUs() {
  return (
    <div className="min-h-screen bg-gray-50">
      <Header />
      <div className="container mx-auto px-4 py-12">
        <div className="max-w-3xl mx-auto">
          <h1 className="text-4xl font-bold mb-8">About Us</h1>

          <div className="bg-white rounded-lg shadow-sm p-8 space-y-6">
            <section>
              <h2 className="text-2xl font-semibold mb-4">Who We Are</h2>
              <p className="text-gray-600 leading-relaxed">
                {config.flightSiteName} is a leading flight booking platform dedicated
                to providing travelers with the best possible experience when
                searching for and booking flights. We work with hundreds of
                airlines worldwide to offer you comprehensive flight options and
                competitive prices.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Our Mission</h2>
              <p className="text-gray-600 leading-relaxed">
                Our mission is to make flight booking simple, transparent, and
                accessible to everyone. We believe in providing clear
                information, competitive prices, and excellent customer service
                to ensure your booking experience is smooth and enjoyable.
              </p>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Why Choose Us</h2>
              <ul className="list-disc list-inside text-gray-600 space-y-2">
                <li>Access to hundreds of airlines worldwide</li>
                <li>Competitive prices and transparent fees</li>
                <li>24/7 customer support</li>
                <li>Secure booking platform</li>
                <li>Easy flight management system</li>
              </ul>
            </section>

            <section>
              <h2 className="text-2xl font-semibold mb-4">Our Values</h2>
              <div className="grid md:grid-cols-2 gap-6">
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Transparency</h3>
                  <p className="text-gray-600">
                    We believe in clear, honest communication with our
                    customers.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Customer First</h3>
                  <p className="text-gray-600">
                    Your satisfaction is our top priority.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Innovation</h3>
                  <p className="text-gray-600">
                    We continuously improve our services to serve you better.
                  </p>
                </div>
                <div className="bg-gray-50 p-4 rounded-lg">
                  <h3 className="font-semibold mb-2">Reliability</h3>
                  <p className="text-gray-600">
                    You can count on us for secure and dependable service.
                  </p>
                </div>
              </div>
            </section>
          </div>
        </div>
      </div>
    </div>
  );
}

export default AboutUs;
